// store/timeStore.ts
import { create } from 'zustand';

interface ITime {
  value: string;
}

interface TimeStore {
  operationTime: string;
  rateId:number;
  setOperationTime: (time: string) => void;
  setRateId: (rateId: number) => void;
}

const useTimeStore = create<TimeStore>((set) => ({
  operationTime: '', 
  setOperationTime: (time) => set({ operationTime: time }),
  rateId: 0,
  setRateId: (rateId) => set({ rateId: rateId })

}));

export default useTimeStore;
